import { render, staticRenderFns } from "./Own.vue?vue&type=template&id=9ab77604"
import script from "./Own.vue?vue&type=script&lang=js"
export * from "./Own.vue?vue&type=script&lang=js"
import style0 from "./Own.vue?vue&type=style&index=0&id=9ab77604&prod&lang=scss"
import style1 from "./Own.vue?vue&type=style&index=1&id=9ab77604&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports